export default {
  EMPTY_NAME: "Please enter name",
  EMPTY_EMAIL: "Please enter email",
  INVALID_EMAIL: "Please enter valid email",
  EMPTY_PHONE: "Please enter phone number",
  INVALID_PHONE: "Please enter valid phone number",
  EMPTY_SUBJECT: "Please enter subject",
  EMPTY_MESSAGE: "Please enter message",
  EMPTY_FIRST_NAME: "Please enter first name",
  EMPTY_LAST_NAME: "Please enter first name",
  EMPTY_COUNTRY: "Please select country",
  EMPTY_STATE: "Please select state",
  EMPTY_SCHOOL_NAME: "Please enter school name",
  EMPTY_SCHOOL_TYPE: "Please select school type",
  EMPTY_SPORTS: "Please select sports",
  EMPTY_PASSWORD: "Please enter password",
};

export const eventConstants = {
  InSeason: "In-Season",
  inSeason: "in-season",
  Game: "Game",
  game: "game",
  Practice: "Practice",
  smallPractice: "practice",
  opponentScout: "opponentScout",
  OpponentScout: "Opponent Scout",
  OffSeason: "Off-Season",
  offSeason: "off-season",
  Other: "Other",
  other: "other",
  highlight: "Highlight",
};

export const userRoleKeyMap = {
  ROLE_TEAM_ADMIN: "teamAdmin",
  ROLE_SCHOOL_ADMIN: "school",
  ROLE_COACH: "coach",
  ROLE_ATHLETE: "athlete",
};

export const userRoleDisplayName = {
  ROLE_TEAM_ADMIN: "Team Admin",
  ROLE_SCHOOL_ADMIN: "School Admin",
  ROLE_COACH: "Coach",
  ROLE_ATHLETE: "Athlete",
};

export const userSchoolName = {
  ROLE_TEAM_ADMIN: "teamSchools",
  ROLE_SCHOOL_ADMIN: "school",
  ROLE_COACH: "coachSchools",
  ROLE_ATHLETE: "athleteSchools",
};

export const userRoles = {
  ROLE_TEAM_ADMIN: "ROLE_TEAM_ADMIN",
  ROLE_SCHOOL_ADMIN: "ROLE_SCHOOL_ADMIN",
  ROLE_COACH: "ROLE_COACH",
  ROLE_ATHLETE: "ROLE_ATHLETE",
};

export const ERROR_MESSAGES = {
  firstNameMax: "must be 15 character or less.",
  firstNameMin: "atleast 3 character required for firstname.",
  firstNameRequired: "First Name is required.",
  nameInvalid: "Please Enter Valid Name.",
  lastNameMax: "must be 15 character or less.",
  lastNameMin: "atleast 3 character required for lastname.",
  lastNameRequired: "Last Name is required.",
  email: "Email is Invalid.",
  emailRequired: "Email is required.",
  emailAlreadyExists: "Email Id Is Used, Please Try with Different Email Id.",
  phoneNumber: "Phone number is not valid.",
  phoneNumberRequired: "Phone Number is Required.",
  graduationYear: "Please Select Graduation Year.",
  positionPlayed: "Enter Valid Played Position.",
  positionPlayedRequired: "Position Played Required.",
  jerseyNumber: "Jersey Number Must be only digits.",
  jerseyNumberRequired: "Jersey Number Required.",
  validUrl: "Enter valid url.",
  schoolNameRequired: "School Name is Required.",
  schoolTypeRequired: "School Type is Required.",
  addressRequired: "Address is Required.",
  countryRequired: "Country is Required.",
  stateRequired: "State is Required.",
  sportRequired: "Sport is Required.",
  Speciality: "Please Select Speciality.",
  eventName: "Please Enter Event Name.",
  playlistName: "Please Enter Playlist Name.",
  eventNameMin: "Event name should be atleast 5 characters.",
  playlistNameMin: "Playlist name should be atleast 3 characters.",
  gameType: "Please select game type.",
  eventLocation: "Please Enter Event Location.",
  eventLocationMin: "Please Enter atleast 5 characters for event name.",
  eventDescription: "Please Enter Description.",
  eventDescriptionMin:
    "Please Enter atleast 20 characters for event Description.",
  eventDate: "Please select event date.",
  eventTime: "Please select event time.",
  teamName: "Please select team.",
  newTeamName: "Please enter new team name.",
  newTeamNameMin: "Please enter atleast 5 characters.",
  groupName: "Please Enter Group Name.",
  maxCharacter: "must be 30 characters or less.",
  minCharacter: "atleast 3 characters required.",
  note: "Note required.",
  amount: "Amount required.",
  paymentMethod: "Please select payment method.",
  paymentStatus: "Please select Payment Status.",
  validity: "Please select validity.",
  invoice: "Please add invoice.",
  playLevel: "Please select play level.",
  question: "Please enter question.",
  answer: "Please enter answer.",
  maxCharacter20: "Must be 20 characters or less.",
  maxCharacter200: "Must be 200 characters or less.",
  maxCharacter300: "Must be 300 characters or less.",
  maxCharacter100: "Must be 100 characters or less.",
  heading: "Please enter heading.",
  subHeading: "Please enter subheading.",
  headerLink: "Please enter menu name.",
  footerDetails: "Please enter details.",
  urlRequired: "Please enter URL.",
  fieldRequired: "Field required.",
  selectFile: "Please select file.",
  Plan: "please select plan.",
  eventType: "Event type is required",
  schoolId: "School ID is required",
  practiceName: "Practice name is required",
  practiceNameMin: "Practice name must not be empty",
  mediaFilesMin: "At least one media file is required",
  fileName: "File name is required",
  fileNameURL: "Invalid URL format",
  filePath: "File path is required",
  seasonType: "Season type is required",
  scheduleId: "Schedule ID is required",
  isPractice: "Specify if it is an off-season event",
  seasonId: "Season ID is required",
};

export const EVENT_TYPES = ["Game", "Practices", "Scout"];

export const POPUP_MESSAGE = {
  hoursRequestSent:
    " Add hours request has been sent Successfully! Please wait for approve!",
  hoursRequestApprove: "Add hours request approved successfully!",
  hoursRequestdisapprove: " Add hours request disapproved successfully!",
};

export const permissionNames = {
  Add_Remove_Coaches: "Add / Remove Coaches",
  Add_Remove_Athletes: "Add / Remove Athletes",
  Add_Remove_Video_Content: "Add / Remove Video Content",
  View_Data_Usage: "View Data Usage",
  View_Invoices: "View Invoices",
  Exchange_Videos: "Exchange Videos",
};

export const playLevels = [
  "Youth",
  "8th Grade",
  "9th Grade",
  "Freshman",
  "Junior varsity",
  "Varsity",
  "D1",
  "D2",
  "D3",
  "Semi-Pro",
  "Indoor Football",
  "XFL",
  "NFL",
];

export const schoolTypes = [
  "Youth",
  "Middle School",
  "High School",
  "College",
  "Semi Pro",
  "Professional",
];

export const playLevelsOptions = [
  {
    name: "Youth",
    id: 1,
  },
  {
    name: "8th Grade",
    id: 2,
  },
  {
    name: "9th Grade",
    id: 3,
  },
  {
    name: "Freshman",
    id: 4,
  },
  {
    name: "Junior varsity",
    id: 5,
  },
  {
    name: "Varsity",
    id: 6,
  },
  {
    name: "D1",
    id: 7,
  },
  {
    name: "D2",
    id: 8,
  },
  {
    name: "D3",
    id: 9,
  },
  {
    name: "Semi-Pro",
    id: 10,
  },
  {
    name: "Indoor Football",
    id: 11,
  },
  {
    name: "XFL",
    id: 12,
  },
  {
    name: "NFL",
    id: 13,
  },
];

export const schoolTypeOptions = [
  {
    name: "Youth",
    id: 1,
  },
  {
    name: "Middle School",
    id: 2,
  },
  {
    name: "High School",
    id: 3,
  },
  {
    name: "College",
    id: 4,
  },
  {
    name: "Semi Pro",
    id: 5,
  },
  {
    name: "Professional",
    id: 6,
  },
];

export const planList = [
  {
    planName: "Gold",
    id: 1,
  },
  {
    planName: "Silver",
    id: 2,
  },
  {
    planName: "Bronze",
    id: 3,
  },
];

export const paymentMethodList = [
  {
    name: "Check",
    id: 1,
  },
  {
    name: "Online",
    id: 2,
  },
];

export const paymentStatusList = [
  {
    name: "Paid",
    id: 1,
  },
  {
    name: "Pending",
    id: 2,
  },
  {
    name: "Overdue",
    id: 3,
  },
];

export const breakDownTypeOptions = [
  {
    name: "Text",
    id: 1,
  },
  {
    name: "Number",
    id: 2,
  },
];
